import React, { useState } from "react";
import CategoryList from "../../component/Category/CategoryList";
import CategoryMobileList from "../../component/Category/CategoryMobileList";
import CategoryForm from "../../component/Category/CategoryForm"
import { useSelector, useDispatch } from 'react-redux';
import GlobalPopup from "../../component/Popup/GlobalPopup.js";
import { openGlobalPopup } from "../../redux/action";
import { useIsMobile } from "../../component/Hooks/useIsMobile.js";

function CategoriesPage() {
  const [action, setAction] = useState(null);
  //const edit = { id: 1, image:"https://github.com/user-attachments/assets/fc5a949f-8931-4c3f-bab5-7db4164f732a", name: "Starters", description: "Appetizers and small bites" }
  // const edit ={ categoryId: '', image:'', name: '', description: '' }
  const edit = useSelector((state) => state?.admin?.edit)
  const categorySaving = useSelector((state) => Boolean(state?.admin?.categorySaving));
  const dispatch = useDispatch();
  const isMobile = useIsMobile();

  const closePopUp = () => {
    dispatch({ type: 'EDIT_CATEGORY', payload: {} });
    setAction(null);
  }

  const openCategoryPopup = (popupAction) => {
    setAction(popupAction);
    dispatch(openGlobalPopup(popupAction));
  };

  const addCategory = () => {
    dispatch({ type: 'EDIT_CATEGORY', payload: {} });
    openCategoryPopup("add-category");
  };
  const editCategory = () => openCategoryPopup("edit-category");

  return (
    <div className="container">
      <h1>Manage Categories</h1>
      {/* <p>Manage Categories and it's food items.</p> */}

      <button
        className="add-button ui-page-add-button"
        onClick={() => { addCategory(); }}
      >Add Category</button>

      <GlobalPopup
        popupKey={action}
        title={edit?.categoryId ? 'Edit Category' : 'Add Category'}
        onClose={closePopUp}
        disableClose={categorySaving}
        footer={(closePopup) => (
          <>
            <button type="button" className="popup-action-btn secondary" onClick={closePopup} disabled={categorySaving}>Cancel</button>
            <button type="submit" form="category-form" className="popup-action-btn" disabled={categorySaving} aria-busy={categorySaving}>
              {categorySaving ? <><span className="popup-button-spinner" aria-hidden="true" />Saving...</> : edit?.categoryId ? 'Edit Category' : 'Add Category'}
            </button>
          </>
        )}
      >
        <CategoryForm edit={edit?.categoryId ? edit : undefined} />
      </GlobalPopup>

      <section className="list-section">
        {isMobile ? (
          <CategoryMobileList onEdit={editCategory} />
        ) : (
          <CategoryList onEdit={editCategory} />
        )}
      </section>
    </div>
  )
}
export default CategoriesPage;
